import {
  InfoCircleOutlined,
  HeartOutlined,
  MedicineBoxOutlined,
  SolutionOutlined,
  SearchOutlined
} from "@ant-design/icons";
import { Space } from "antd";
// import { VscGitPullRequestNewChanges } from "react-icons/vsc";

export const conditionTabs = [
  { key: "0", label: "Overview", icon: <InfoCircleOutlined /> },
  { key: "1", label: "Signs & Symptoms", icon: <HeartOutlined /> },
  { key: "3", label: "Treatments", icon: <MedicineBoxOutlined /> },
  { key: "4", label: "Management", icon: <SolutionOutlined /> },
  { key: "2", label: "Investigations", icon: <SearchOutlined /> },
];

export const ExtraTabsWrapper = ({ children }) => {
  return (
    <Space style={{ flex: "1 1 auto" }}>
      {/* {form?.isFieldsTouched() && (
        <span style={{ color: "gray", fontStyle: "italic", fontSize: "14px" }}>
          <VscGitPullRequestNewChanges />
          Unsaved
        </span>
      )} */}
      {children}
    </Space>
  );
};

export const TabPane = ({ ...props }) => {
  return (
    props?.children && (
      <div
        style={{
          marginBottom: 24,
          background: "#fafafa",
          padding: 8,
          borderRadius: 8,
        }}
      >
        {props?.children}
      </div>
    )
  );
};

export const TabManager = ({ activeTab }) => {
  return null; // Placeholder for tab content
};

export const handleTabChange = (
  key,
  { headerText, setHeaderText, setActiveTab, setTabView }
) => {
  setHeaderText(headerText);
  switch (key) {
    case "1":
      setActiveTab("Condition");
      setTabView();
      break;
    case "2":
      setActiveTab("Condition");
      setTabView("signs-symptoms");
      break;
    case "3":
      setActiveTab("Condition");
      setTabView("treatments");
      break;
    case "4":
      setActiveTab("Condition");
      setTabView("investigations");
      break;
    case "5":
      setActiveTab("Condition");
      setTabView("patient-info");
      break;
    case "6":
      setActiveTab("Quiz");
      setTabView();
      break;
    case "7":
      setActiveTab("Nodes");
      setTabView();
      break;
    default:
      setTabView();
      break;
  }
};